import { proofApiFetch } from './proof-api-client';
import {
  storePulseAlertCountsResponseSchema,
  storePulseAlertListResponseSchema,
  storePulseNetworkStatusResponseSchema,
  storePulseAlertDecisionResponseSchema,
  type StorePulseAlertDecision,
} from '@/lib/store-pulse/alerts-contract';

export interface StorePulseAlertListFilter {
  severity?: readonly string[];
  state?: readonly string[];
  location?: string;
}

function listQueryString(filter: StorePulseAlertListFilter): string {
  const params = new URLSearchParams();
  if (filter.severity?.length) params.set('severity', filter.severity.join(','));
  if (filter.state?.length) params.set('state', filter.state.join(','));
  if (filter.location) params.set('location', filter.location);
  const query = params.toString();
  return query ? `?${query}` : '';
}

export const storePulseAlertsService = {
  counts: () => proofApiFetch('/api/store-pulse-alerts?view=counts', storePulseAlertCountsResponseSchema),
  networkStatus: () => proofApiFetch('/api/store-pulse-alerts?view=network_status', storePulseNetworkStatusResponseSchema),
  list: (filter: StorePulseAlertListFilter = {}) =>
    proofApiFetch(`/api/store-pulse-alerts${listQueryString(filter)}`, storePulseAlertListResponseSchema),
  decide: (decision: StorePulseAlertDecision) =>
    proofApiFetch('/api/store-pulse-alerts', storePulseAlertDecisionResponseSchema, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(decision),
    }),
};
